/** YouTube URL helpers: video id from any share/watch/embed/shorts URL, and its static thumbnail. */

export function youtubeVideoId(youtubeUrl: string): string | null {
  const parsers: Array<[RegExp, (executed: string[]) => string]> = [
    [/youtu\.be\/([^?]*)/i, executed => executed[1]],
    [/v=([^&#]+)/i, executed => executed[1]],
    [/embed\/([^?#]+)/i, executed => executed[1]],
    [/shorts\/([^?#]+)/i, executed => executed[1]],
  ]

  for (const parser of parsers) {
    const executed = parser[0].exec(youtubeUrl)
    if (executed) {
      return parser[1](executed)
    }
  }

  return null
}

/**
 * Static YouTube thumbnail for a video id. `mqdefault` (320x180, 16:9) and `hqdefault`
 * (480x360, 4:3 with letterbox bars) exist for every video; the larger `sddefault` /
 * `maxresdefault` variants are missing for older uploads and 404 (or serve a grey
 * placeholder), so they are deliberately not offered here.
 */
export type YoutubeThumbnailQuality = 'mqdefault' | 'hqdefault'

export function youtubePreviewImage(
  youtubeId: string,
  quality: YoutubeThumbnailQuality = 'mqdefault'
): string {
  return `https://img.youtube.com/vi/${youtubeId}/${quality}.jpg`
}
